// Title and text of a toast raised through globalNotification.request
export const buildRequestNotificationText = (t, { type, resource, action, plural }) => {
    const nounType = plural ? 'plural' : 'singular';

    const resourceText = t(`notifications:resources.${resource}.${nounType}`);

    return {
        message: t(`general:${type}`),
        description: t(`notifications:${type}`, {
            resource: resourceText,
            // for sentences that need the noun mid-sentence or the verb's base form ("Failed to update the job")
            resourceLower: resourceText.toLowerCase(),
            verb: t(`general:actions.simple.${action}`, { defaultValue: action }).toLowerCase(),
            noun: t(`notifications:noun.${nounType}`),
            action: t(`general:actions.continuous.${action}`).toLowerCase(),
        }),
    };
};
